export const isAndroidDevice = () => navigator.userAgent.toLowerCase().includes('android');

export const isIosDevice = () => {
  console.log('navigator.userAgent', navigator.userAgent);
  let isSafariIpad = /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints && navigator.maxTouchPoints > 1;
  return isSafariIpad || /iPad|iPhone|iPod/.test(navigator.userAgent)
}